import { toast } from 'react-toastify';
import {API_URL} from '../utils/url';

const getData = async (route, params = {}) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`;

    const queryParams = new URLSearchParams(params).toString();
    const sessionToken = sessionStorage.getItem("Token"); // Get stored token

    const response = await fetch(`${URL_ROUTE}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${sessionToken}` // Include token for authentication
      }
    });

    if (response.status === 401) {
      toast.error("Session timed out. Please login to continue.");
      window.location.href = '/login';
      return;
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    return await response.json();
  } catch (e) {
    console.error("API Error:", e);
    throw e;
  }
};


const postData = async (route, data, token) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`.replace(/\/+$/, "");

    console.log("Sending Request to:", URL_ROUTE);
    console.log("Request Body:", JSON.stringify(data));

    const response = await fetch(URL_ROUTE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,

      },
      body: JSON.stringify(data),
    });

    if (response.status === 401) {
      toast.error("Session timed out. Please login to continue.");
      window.location.href = '/login';
      return;
    }

    console.log("Response Status:", response.status);

    const responseData = await response.json(); // Parse JSON once

    if (!response.ok) {
      console.error("Response Error:", responseData);
      throw new Error(responseData.message || `Error: ${response.status}`);
    }

    console.log("Response Data:", responseData);
    return responseData;
  } catch (e) {
    console.error("Unexpected Error:", e.message);
    throw e;
  }
};

const postDataBulkUpload = async (route, data, token) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`.replace(/\/+$/, "");

    console.log("Sending Request to:", URL_ROUTE);
    console.log("Request Body:", data);

    const response = await fetch(URL_ROUTE, {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,

      },
      body: data,
    });

    if (response.status === 401) {
      toast.error("Session timed out. Please login to continue.");
      window.location.href = '/login';
      return;
    }

    console.log("Response Status:", response.status);

    const responseData = await response.json(); // Parse JSON once

    if (!response.ok) {
      console.error("Response Error:", responseData);
      throw new Error(responseData.message || `Error: ${response.status}`);
    }

    console.log("Response Data:", responseData);
    return responseData;
  } catch (e) {
    console.error("Unexpected Error:", e.message);
    throw e;
  }
};

const patchData = async (route, body = {}) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`;
    const sessionToken = sessionStorage.getItem("Token"); // Get stored token

    const response = await fetch(URL_ROUTE, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${sessionToken}` // Include token for authentication
      },
      body: JSON.stringify(body) // Send the patch data
    });

    if (response.status === 401) {
      alert("Session timed out. Please login to continue.");
      window.location.href = '/login';
      return;
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    return await response.json();
  } catch (e) {
    console.error("API Error:", e);
    throw e;
  }
};


const putData = async (route, data, token) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`.replace(/\/+$/, "");

    console.log("Sending PUT Request to:", URL_ROUTE);
    console.log("Request Body:", JSON.stringify(data));

    const response = await fetch(URL_ROUTE, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (response.status === 401) {
      toast.error("Session timed out. Please login to continue.");
      window.location.href = '/login';
      return;
    }

    console.log("Response Status:", response.status);

    const responseData = await response.json(); // Parse JSON once

    if (!response.ok) {
      console.error("Response Error:", responseData);
      throw new Error(responseData.message || `Error: ${response.status}`);
    }

    console.log("Response Data:", responseData);
    return responseData;
  } catch (e) {
    console.error("Unexpected Error:", e.message);
    throw e;
  }
};

const deleteData = async (route, token) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`.replace(/\/+$/, "");

    console.log("Sending DELETE Request to:", URL_ROUTE);

    const response = await fetch(URL_ROUTE, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });

    if (response.status === 401) {
      toast.error("Session timed out. Please login to continue.");
      window.location.href = '/login';
      return;
    }

    console.log("Response Status:", response.status);

    if (!response.ok) {
      const responseData = await response.json();
      console.error("Response Error:", responseData);
      throw new Error(responseData.message || `Error: ${response.status}`);
    }

    console.log("User deleted successfully!");
    return { success: true, message: "Deleted successfully" };
  } catch (e) {
    console.error("Unexpected Error:", e.message);
    throw e;
  }
};

const uploadFile = async (route, file) => {

  const URL_ROUTE = `${API_URL}${route}`;

  try {
    if (!file) {
      return { success: false, message: "No file selected" };
    }

    const response = await fetch(URL_ROUTE, {
      method: "POST",
      body: file,
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("File Upload Error:", error);
    return { success: false, message: "Error uploading file" };
  }
};


export { getData, postData, putData, deleteData, uploadFile, postDataBulkUpload, patchData };
